import { render, staticRenderFns } from "./DIASEstateSelection.vue?vue&type=template&id=f10ffd84&"
import script from "./DIASEstateSelection.vue?vue&type=script&lang=js&"
export * from "./DIASEstateSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports